import React from 'react';
import { SectionWrapper } from './ui/SectionWrapper';
export function OpeningHook() {
  return <SectionWrapper className="bg-white" data-id="element-89">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-90">
        <div className="border-l-4 border-brand-teal pl-6 md:pl-10 py-2" data-id="element-91">
          <p className="text-xl md:text-2xl text-gray-800 leading-relaxed font-medium mb-6" data-id="element-92">
            Si hoy te levantaste, te miraste al espejo y sentiste que tu cara y
            tu abdomen no te pertenecen, no estás solo. Ese anillo que ya no
            entra en tu dedo o ese pantalón que te aprieta al cerrar no es "solo
            grasa"; es tu cuerpo gritando por ayuda bajo el peso de la
            inflamación sistémica.
          </p>
          <p className="text-lg md:text-xl text-gray-600 leading-relaxed" data-id="element-93">
            No es tu edad, ni es falta de voluntad. Es el ritmo de vida en este
            país, el estrés del cortisol y una industria alimentaria que diseña
            productos para mantenerte hinchado, cansado y dependiente de
            soluciones que no funcionan.
          </p>
        </div>
      </div>
    </SectionWrapper>;
}